
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "id": "_",
    "data-name": "+",
    "xmlns": "http://www.w3.org/2000/svg",
    "viewBox": "0 0 20 20"
  },
  "children": [
    {
      "tag": "title",
      "children": [
        {
          "text": "创建白板"
        }
      ]
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M17,0H3A3,3,0,0,0,0,3V17a3,3,0,0,0,3,3H17a3,3,0,0,0,3-3V3A3,3,0,0,0,17,0ZM15,11H11v4a1,1,0,0,1-2,0V11H5A1,1,0,0,1,5,9H9V5a1,1,0,0,1,2,0V9h4a1,1,0,0,1,0,2Z",
        "transform": "translate(0 0)",
        "style": "fill:#c7d4e8"
      }
    }
  ]
})
    }
  